import { useSessionContext } from '@shared/hooks'
import { _Application } from '@shared/types/custom/_Application'
import { Row, theme } from 'antd'

import { ApplicationItem } from './ApplicationItem'
import { CreateApplicationCard } from './CreateApplicationCard'

type Props = {
  onOpenModal: () => void
  applicationList?: _Application[]
}

export const ApplicationList = ({ onOpenModal, applicationList }: Props) => {
  const { token } = theme.useToken()
  const { isAdmin } = useSessionContext()

  return (
    <Row gutter={[16, 16]}>
      {isAdmin && <CreateApplicationCard onOpenModal={onOpenModal} />}

      {applicationList?.map((app) => {
        return (
          <ApplicationItem
            key={app?.id}
            backgroundColor={token.colorWhite}
            item={app}
          />
        )
      })}
    </Row>
  )
}
